export enum MarketingPreferencesTestHooks {
  Form = 'marketing-preferences-form',
  MarketingPreferenceEmailCheckbox = 'marketing-preferences-email-checkbox',
  MarketingPreferenceTelephoneCheckbox = 'marketing-preferences-telephone-checkbox',
  MarketingPreferencePostCheckbox = 'marketing-preferences-post-checkbox',
}
